<template>
  <App>
    <datatable
        :filters="filters"
        :headers="headers"
        :items="usuariosTable"
        :loading="form.processing"
    >
      <template #filters>
        <div class="card-title">
          <div class="d-flex align-items-center position-relative">
                        <span class="position-absolute ms-6">
                            <i class="fas fa-search"></i>
                        </span>
            <input data-kt-customer-table-filter="search"
                   v-model="filters.name"
                   type="text"
                   class="form-control form-control-solid w-450px ps-15"
                   placeholder="Nome do usuário"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">

        </div>
      </template>

<!--      <template v-slot:cell.group="{row}">-->
<!--        {{ row.group.name }}-->
<!--      </template>-->

      <template v-slot:cell.actions="{row}">
        <Link :href="this.route('app.usuarios.edit', row.id)"
              method="get"
              as="button"
              class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              title="Editar o usuário"
              data-bs-original-title="Ver usuário">
          <i class="fs-2 bi bi-pencil-square"></i>
        </Link>
        <a href="#" @click="remove(row.id)" v-if="(row.id !== 1 && row.id !== 2)" class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           title="Remover">
          <i class="fs-2 bi bi-trash"></i>
        </a>

        <a href="#" @click="personificacao(row.id)" v-if="(row.id !== 1 && row.id !== 2) && can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Personificar">
          <i class="fs-2 bi bi-door-open"></i>
        </a>
      </template>
    </datatable>
  </App>
</template>
<script>
import App from "@layout/App";
import axios from "axios";
import {ref} from "vue";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import {success, error} from "@settings/toastr";

export default {
  props: ['usuarios'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
    Datatable
  },

  data: _ => ({
    headers: [
      {text: 'Código', value: 'id'},
      {text: 'Nome', value: 'name', searchable: true},
      {text: 'E-mail', value: 'email', searchable: true},
      {text: 'Tipo', value: 'tipo', searchable: true},
      {text: 'Ações', value: 'actions'},
    ],
    filters: {
      name: null,
      email: null,
      tipo: null,
    }
  }),

  mounted() {
    this.init();
  },

  setup(props) {
    const usuariosTable = ref(props.usuarios);

    const form = useForm({
      usuario: null,
    });

    return {
      usuariosTable, form
    }
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Usuários');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Usuários'},
      ]);

      this.emitter.emit('action', {
            show: true,
            title: 'Novo Usuário',
            link: this.route('app.usuarios.create')
          }
      );
    },

    clearFilters() {
      Object.keys(this.filters).forEach(k => this.filters[k] = null);
    },

    list() {
      axios.get(this.route('app.usuarios.filter'))
          .then(response => this.usuariosTable = response.data)
    },

    remove(userId) {
      this.form.usuario = userId;
      this.emitter.emit('alert', {
        success: this.confirmDelete
      });
    },

    personificacao(userId) {
      this.form.usuario = userId;
      this.emitter.emit('alert', {
        title: 'Confirma a personificação?',
        text: 'Você será desconectado e passará acessar a conta do usuário em questão.',
        success: this.confirmPersonificacao
      });
    },

    confirmPersonificacao() {
      this.form.post(this.route('app.usuarios.personification', {id: this.form.usuario}), {
        onError: error,
        onSuccess: () => {
          window.location.reload()
        }
      });
    },

    confirmDelete() {
      this.form.delete(this.route('app.usuarios.delete', {id: this.form.usuario}), {
        onError: error,
        onSuccess: () => {
          success('Usuário excluído com sucesso!');
          setTimeout( () => {
            window.location.reload()
          }, 1000)
        }
      });
    },
  },
};
</script>
